/**
 * @description Application configuration for the Time Clock portal
 *
 * Key features:
 * - API URL resolution (env var or default)
 * - Session TTL constant
 * - App-wide configuration values
 *
 * @notes
 * - REACT_APP_API_URL should point to the shared backend
 * - Default localhost:5001 for local development
 */

const config = {
  apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:5001',
  sessionTtlMinutes: 30,
  pinMinLength: 4,
  pinMaxLength: 6,
  historyDefaultLimit: 14,
  scheduleRangeDays: 14,
};

export default config;
